import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-forest-dark text-cream/60 py-12 px-6 text-center border-t border-forest" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <div className="font-serif text-2xl text-gold mb-6" data-id="element-43">
          The Longevity Dog
        </div>
        <p className="text-xs mb-6 max-w-2xl mx-auto leading-relaxed opacity-70" data-id="element-44">
          Disclaimer: The information provided on this website and in our
          products is for educational purposes only. It is not intended as a
          substitute for professional veterinary advice, diagnosis, or
          treatment. Always seek the advice of your veterinarian with any
          questions you may have regarding your pet's medical condition.
          Statements have not been evaluated by the FDA.
        </p>
        <div className="flex justify-center gap-6 text-xs uppercase tracking-wider mb-8" data-id="element-45">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-46">
            Terms
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-47">
            Privacy
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-48">
            Contact
          </a>
        </div>
        <p className="text-xs opacity-50" data-id="element-49">
          &copy; {new Date().getFullYear()} The Longevity Dog. All rights
          reserved.
        </p>
      </div>
    </footer>;
};